"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Alert = void 0;
const react_1 = __importStar(require("react"));
const ri_1 = require("react-icons/ri");
const react_2 = require("@chakra-ui/react");
function Alert(_a) {
    var { children, dir = "row", title, type, withClose, withIcon = true } = _a, rest = __rest(_a, ["children", "dir", "title", "type", "withClose", "withIcon"]);
    const theme = react_2.useTheme();
    const { bgColor, icon } = react_1.useMemo(() => {
        switch (type) {
            case "error":
                return {
                    bgColor: "danger.100",
                    icon: (react_1.default.createElement(ri_1.RiErrorWarningFill, { color: theme.colors.danger[600], fontSize: "20px", style: { marginTop: "2px", minWidth: "20px" } })),
                };
            case "info":
                return {
                    bgColor: "info.100",
                    icon: (react_1.default.createElement(ri_1.RiInformationFill, { color: theme.colors.info[600], fontSize: "20px", style: { marginTop: "2px", minWidth: "20px" } })),
                };
            case "success":
                return {
                    bgColor: "success.100",
                    icon: (react_1.default.createElement(ri_1.RiCheckboxCircleFill, { color: theme.colors.success[700], fontSize: "20px", style: { marginTop: "2px", minWidth: "20px" } })),
                };
            case "warning":
                return {
                    bgColor: "warning.100",
                    icon: (react_1.default.createElement(ri_1.RiErrorWarningFill, { color: theme.colors.warning[700], fontSize: "20px", style: { marginTop: "2px", minWidth: "20px" } })),
                };
        }
    }, [type]);
    return (react_1.default.createElement(react_2.Flex, Object.assign({ alignItems: "flex-start", flexDirection: dir === "row" ? "row" : "column", bg: bgColor, borderRadius: "8px", color: "darkgray.800", padding: "16px" }, rest),
        withIcon && (react_1.default.createElement(react_1.default.Fragment, null,
            icon,
            " ",
            react_1.default.createElement(react_2.Spacer, { w: "12px", maxW: "12px", minW: "12px" }))),
        title && (react_1.default.createElement(react_1.default.Fragment, null,
            react_1.default.createElement(react_2.chakra.p, { fontWeight: "bold", textStyle: "body1" }, title),
            react_1.default.createElement(react_2.Spacer, { w: "12px", maxW: "12px", minW: "12px" }))),
        react_1.default.createElement(react_2.chakra.p, { textStyle: "body1" }, children),
        withClose && (react_1.default.createElement(react_1.default.Fragment, null,
            react_1.default.createElement(react_2.Spacer, { w: "12px", maxW: "12px", minW: "12px" }),
            react_1.default.createElement(react_2.CloseButton, { style: { marginTop: "-4px" } })))));
}
exports.Alert = Alert;
//# sourceMappingURL=Alert.js.map